<section class="container section-gap">
  <ng-container *ngIf="config.layout === 'full-width'">
    <div class="row">
      <div class="col-12">
        <kla-title [config]="titleConfig" [lineConfig]="lineConfig"></kla-title>
      </div>
      <div class="col-12">
        <ng-container *ngTemplateOutlet="swiper"></ng-container>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="config.layout === 'right'">
    <div class="row">
      <div class="col-12 col-lg-6">
        <kla-title [config]="titleConfig" [lineConfig]="lineConfig"></kla-title>
      </div>
      <div class="col-12 col-lg-6">
        <ng-container *ngTemplateOutlet="swiper"></ng-container>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="config.layout === 'left'">
    <div class="row">
      <div class="col-12 col-lg-6">
        <ng-container *ngTemplateOutlet="swiper"></ng-container>
      </div>
      <div class="col-12 col-lg-6">
        <kla-title [config]="titleConfig" [lineConfig]="lineConfig"></kla-title>
      </div>
    </div>
  </ng-container>
</section>


<ng-template #swiper>
  <div id="{{swiperId}}" class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" *ngFor="let item of config.items"
           [ngStyle]="{'background-image': 'url(' + getImagePath(item.image) +')'}">
        <div class="w-100 h-100 caption d-flex align-items-end">
          <div class="gradient w-75 py-2 mb-4" *ngIf="item.description">
            <p class="text-white px-2 mb-0">{{item.description}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    <div class="swiper-pagination"></div>
  </div>
</ng-template>
